<template>
    <div>
        <div class="p-d-flex">
            <Toast />
        </div>
        <Dialog :visible.sync="dialogNotas" :closable="false" :containerStyle="{ width: '600px' }" :modal="true">
            <div class="card">
                <div class="p-d-flex p-fluid grid formgrid">
                    <div class="text-left field col-3">
                        <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined"
                            @click="dialogNotas = false" />
                    </div>
                    <div class="text-center field col-6">
                        <h2>{{ textoNotas }}</h2>
                    </div>
                    
                </div>
                <hr size=7 color="#ED6421">
                <div>
                    <Editor readonly :value="detalleNotas" class="editor1" style="font-size: 15px;">
                        <template hidden #toolbar>
                            <span hidden class="ed ql-formats">
                            </span>
                        </template>
                    </Editor>
                </div>
            </div>
        </Dialog>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>
        <!-- DIALOG DE COMPARATIVA -->
        <Dialog :visible.sync="dialogComparativa" :closable="false" :containerStyle="{ width: '800px' }" :modal="true">
            <div class="card">
                <div>
                    <comparativa @closeDialogComparativa="CloseComparativa"></comparativa>
                </div>
            </div>
        </Dialog>
        <!-- DIALOG DE LOS DETALLES -->
        <Sidebar :visible.sync="dialogDetalles" position="full" :showCloseIcon="false">
            <div class="card">
                <div>
                    <detalles @closeDialogComparativa="CloseComparativa"></detalles>
                </div>
            </div>
        </Sidebar>

        <div class="card">
            <div class="flex justify-content-center flex-wrap card-container">
                <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left; width:200px" v-model="selectedMes" :options="itemsMes" optionLabel="mes" />
                        <label>Mes</label>
                    </span>
                </div>
                <div class="flex align-items-center justify-content-center w-4rem h-4rem m-2">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left; width:110px" v-model="selectedAnio" :options="itemsAnios" />
                        <label>Año</label>
                    </span>
                </div>
                <div class="flex align-items-center justify-content-center w-6rem h-4rem m-2">
                    <div>
                        <Button icon="mdi mdi-text-box-search-outline" class="p-button-text p-button-rounded" @click="Consultar()" v-tooltip.bottom="'Consultar'" style="color:#FBC31F"/>
                    </div>
                    <div>
                        <Button icon="mdi mdi-file-excel-box" class="p-button-text p-button-rounded" @click="ExportExcel()" v-tooltip.bottom="'Exportar a Excel'" style="color:#107C41"/>
                    </div>
                </div>
            </div>
            <!-- TABLA DE SUELDOS Y SALARIOS -->
            <DataTable :value="itemsSueldos" :scrollable="true" scrollHeight="560px" scrollDirection="both" >
                <template #header>
                    <div class="text-center p-d-flex justify-center p-fluid grid formgrid">
                        <div class="col-12 text-center pa-0 ma-0 pl-3">
                            <h1>Sueldos y Salarios ({{ sumaSueldos }})</h1>
                            <Button icon="mdi mdi-information" class="p-button-text p-button-rounded" @click="OpenNotas(1)" v-tooltip.bottom="'Información'" style="color:#24ACF2"/>
                            <Button icon="mdi mdi-compare" class="p-button-text p-button-rounded" @click="OpenDialoComparativa(1)" v-tooltip.bottom="'Comparativa'" style="color:#3EBF4F"/>
                        </div>
                    </div>
                </template>
                <Column header="Acciones" :styles="{'width':'1rem', 'min-width':'5rem'}" :exportable="false">
                    <template #body="slotProps">
                        <Button icon="mdi mdi-format-list-bulleted" class="p-button-text p-button-rounded" v-tooltip.bottom="'Detalle'" @click="OpenDialogDetalle(slotProps.data, 'Sueldos y Salarios')" />
                    </template>
                </Column>
                <Column field="mes" header="MES" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="importe" header="IMPORTE" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.importe) }}</span>
                      </template>
                </Column>
                <!-- <Column field="comparativa" header="COMPARATIVA" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.comparativa) }}</span>
                      </template>
                </Column>
                <Column field="diferencia" header="DIFERENCIA" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.diferencia) }}</span>
                      </template>
                </Column> -->
            </DataTable>
            <!-- TABLA DE ASIMILADOS -->
            <DataTable :value="itemsAsimilados" :scrollable="true" scrollHeight="560px" scrollDirection="both" >
                <template #header>
                    <div class="text-center p-d-flex justify-center p-fluid grid formgrid">
                        <div class="col-12 text-center pa-0 ma-0 pl-3">
                            <h1>Asimilados ({{ sumaAsimilados }})</h1>
                            <Button icon="mdi mdi-information" class="p-button-text p-button-rounded" @click="OpenNotas(2)" v-tooltip.bottom="'Información'" style="color:#24ACF2"/>
                            <Button icon="mdi mdi-compare" class="p-button-text p-button-rounded" @click="OpenDialoComparativa(2)" v-tooltip.bottom="'Comparativa'" style="color:#3EBF4F"/>
                        </div>
                    </div>
                </template>
                <Column header="Acciones" :styles="{'width':'1rem', 'min-width':'5rem'}" :exportable="false">
                    <template #body="slotProps">
                        <Button icon="mdi mdi-format-list-bulleted" class="p-button-text p-button-rounded" v-tooltip.bottom="'Detalle'" @click="OpenDialogDetalle(slotProps.data, 'Asimilados')" />
                    </template>
                </Column>
                <Column field="mes" header="MES" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="importe" header="IMPORTE" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.importe) }}</span>
                      </template>
                </Column>
                <!-- <Column field="comparativa" header="COMPARATIVA" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.comparativa) }}</span>
                      </template>
                </Column>
                <Column field="diferencia" header="DIFERENCIA" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.diferencia) }}</span>
                      </template>
                </Column> -->
            </DataTable>
            <!-- TABLA DE OTROS -->
            <DataTable :value="itemsOtros" :scrollable="true" scrollHeight="560px" scrollDirection="both" >
                <template #header>
                    <div class="text-center p-d-flex justify-center p-fluid grid formgrid">
                        <div class="col-12 text-center pa-0 ma-0 pl-3">
                            <h1>Sueldos Otros ( {{sumaOtros}} )</h1>
                            <Button icon="mdi mdi-information" class="p-button-text p-button-rounded" @click="OpenNotas(3)" v-tooltip.bottom="'Información'" style="color:#24ACF2"/>
                            <Button icon="mdi mdi-compare" class="p-button-text p-button-rounded" @click="OpenDialoComparativa(3)" v-tooltip.bottom="'Comparativa'" style="color:#3EBF4F"/>
                        </div>
                    </div>
                </template>
                <Column header="Acciones" :styles="{'width':'1rem', 'min-width':'5rem'}" :exportable="false">
                    <template #body="slotProps">
                        <Button icon="mdi mdi-format-list-bulleted" class="p-button-text p-button-rounded" v-tooltip.bottom="'Detalle'" @click="OpenDialogDetalle(slotProps.data, 'Sueldos Otros')" />
                    </template>
                </Column>
                <Column field="mes" header="MES" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="importe" header="IMPORTE" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.importe) }}</span>
                      </template>
                </Column>
                <!-- <Column field="comparativa" header="COMPARATIVA" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.comparativa) }}</span>
                      </template>
                </Column>
                <Column field="diferencia" header="DIFERENCIA" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.diferencia) }}</span>
                      </template>
                </Column> -->
            </DataTable>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";
    import XLSX from 'xlsx'
    import comparativa from './Comparativa.vue'
    import detalles from './ReporteDetalles.vue'

    export default {
        components: {
            comparativa,
            detalles
        },
        data() {
            return {
                sueldos: [],
                asimilados: [],
                otros: [],
                itemsAnios: ['2023','2022','2021','2020','2019','2018'],
                itemsMes: [
                    { mes: 'ENERO', valor: 1 },
                    { mes: 'FEBRERO', valor: 2 },
                    { mes: 'MARZO', valor: 3 },
                    { mes: 'ABRIL', valor: 4 },
                    { mes: 'MAYO', valor: 5 },
                    { mes: 'JUNIO', valor: 6 },
                    { mes: 'JULIO', valor: 7 },
                    { mes: 'AGOSTO', valor: 8 },
                    { mes: 'SEPTIEMBRE', valor: 9 },
                    { mes: 'OCTUBRE', valor: 10 },
                    { mes: 'NOVIEMBRE', valor: 11 },
                    { mes: 'DICIEMBRE', valor: 12 },
                ],

                selectedAnio: null,
                selectedMes: null,

                //TABLAS
                itemsSueldos: [],
                itemsAsimilados: [],
                itemsOtros: [],

                dialogNotas: false,
                textoNotas: '',
                detalleNotas: '',

                //LOADING
                loading: false,
                loadingMensaje: '',

                //COMPARATIVA
                dialogComparativa: false,
                textComnparativa: '',
                tablaInicial: [
                    { mes:'enero', comparativa: 0 },
                    { mes:'febrero', comparativa: 0 },
                    { mes:'marzo', comparativa: 0 },
                    { mes:'abril', comparativa: 0 },
                    { mes:'mayo', comparativa: 0 },
                    { mes:'junio', comparativa: 0 },
                    { mes:'julio', comparativa: 0 },
                    { mes:'agosto', comparativa: 0 },
                    { mes:'septiembre', comparativa: 0 },
                    { mes:'octubre', comparativa: 0 },
                    { mes:'noviembre', comparativa: 0 },
                    { mes:'diciembre', comparativa: 0 },
                ],
            
                //DETALLES
                dialogDetalles: false,

                rutaAxios : 'https://api-mongo.contago.com.mx/api/',
                // rutaAxios : 'https://localhost:44322/api/',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },

            comparativa(){
                return this.$store.state.comparativaStore;
            },

            sumaSueldos(){
                let suma = this.itemsSueldos.reduce((acumulador, objeto) => acumulador + objeto.importe, 0);
                let resultado = this.formatCurrency(suma);
                return resultado;
            },

            sumaAsimilados(){
                let suma = this.itemsAsimilados.reduce((acumulador, objeto) => acumulador + objeto.importe, 0);
                let resultado = this.formatCurrency(suma);
                return resultado;
            },

            sumaOtros(){
                let suma = this.itemsOtros.reduce((acumulador, objeto) => acumulador + objeto.importe, 0);
                let resultado = this.formatCurrency(suma);
                return resultado;
            },
            
        },
        created() {

        },
        methods: {
            async Consultar(){
                this.loading = true;
                this.loadingMensaje = 'Consultando, espere...'
                let fechaI = this.selectedAnio + '-01-01';
                let fechaF = this.selectedAnio + '-' +  this.selectedMes.valor + '-01';
                try{
                    let response = await axios.get('ReporteNominas/GetReporteISr/'+ this.token.empresaBase + '/' + fechaI + '/' + fechaF);
                    let res = response.data;
                    this.itemsSueldos = res[0]
                    this.itemsAsimilados = res[1]
                    this.itemsOtros = res[2]
                    this.loading = false
                }catch(error){
                    console.log(error)
                    this.loading = false;
                }
            },

            OpenNotas(item){
                this.dialogNotas = true;
                if(item == 1){
                    this.textoNotas = 'Sueldos y Salarios';
                    this.detalleNotas = '♦ 02 | Sueldos (Incluye ingresos señalados en la fracción I del artículo 94 de LISR)';
                }
                if(item == 2){
                    this.textoNotas = 'Asimilados';
                    this.detalleNotas = '♦ 05 | Asimilados Miembros Sociedades Cooperativas Produccion<br>♦ 06 | Asimilados Integrantes Sociedades Asociaciones Civiles<br>♦ 07 | Asimilados Miembros consejos<br>♦ 08 | Asimilados comisionistas<br>♦ 09 | Asimilados Honorarios<br>♦ 10 | Asimilados acciones<br>♦ 11 | Asimilados otros';
                }
                if(item == 3){
                    this.textoNotas = 'Sueldos Otros';
                    this.detalleNotas = '♦ 03 | Jubilados<br>♦ 04 | Pensionados<br>♦ 12 | Jubilados o Pensionados<br>♦ 13 | Indemnización o Separación<br>♦ 99 | Otro Regimen';
                }
            },

            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            ExportExcel(){
                const sueldosFiltrados = this.itemsSueldos.map((fila) => {
                    const { ["detalles"]: columnaExcluida, ...restoDeColumnas } = fila;
                    return restoDeColumnas;
                });

                const asimiladosFiltrados = this.itemsAsimilados.map((fila) => {
                    const { ["detalles"]: columnaExcluida, ...restoDeColumnas } = fila;
                    return restoDeColumnas;
                });
                
                const otrosFiltrados = this.itemsOtros.map((fila) => {
                    const { ["detalles"]: columnaExcluida, ...restoDeColumnas } = fila;
                    return restoDeColumnas;
                });

                const workbook = XLSX.utils.book_new();

                const sheetSueldos = XLSX.utils.json_to_sheet(sueldosFiltrados);
                XLSX.utils.book_append_sheet(workbook, sheetSueldos, 'SUELDOS Y SALARIOS');

                const sheetAsimilados = XLSX.utils.json_to_sheet(asimiladosFiltrados);
                XLSX.utils.book_append_sheet(workbook, sheetAsimilados, 'ASIMILADOS');

                const sheetOtros = XLSX.utils.json_to_sheet(otrosFiltrados);
                XLSX.utils.book_append_sheet(workbook, sheetOtros, 'OTROS');


                XLSX.writeFile(workbook, 'ISR Sueldos_enero_'+ this.selectedMes.mes + '_' + this.selectedAnio +'.xlsx');
            },
        
            async ConsultaMongoDb(){
                try{
                    this.loading = true;
                    this.loadingMensaje = 'Consultando, espere...'

                    //CONSULTANOS LAS COMPARATIVAS
                    let comparativaSueldos = await this.GetComparativa(this.selectedAnio, 'Sueldos');
                    let comparativaAsimilados = await this.GetComparativa(this.selectedAnio, 'Asimilados');
                    let comparativaOtros = await this.GetComparativa(this.selectedAnio, 'SueldosOtros');
                    
                    //CONSULTAMOS LOS IMPORTES
                    let fechaI = this.selectedAnio + '-01-01';
                    let fechaF = this.selectedAnio + '-' +  this.selectedMes.valor + '-01';
                    let response =  await axios.get(this.rutaAxios + 'Nomina/GetReporteISrAsync/' + this.token.empresaBase + '/' + fechaI + '/' + fechaF);
                    let res = response.data;
                    this.itemsSueldos = res[0]
                    this.itemsAsimilados = res[1]
                    this.itemsOtros = res[2]
                    console.log(this.itemsSueldos)

                    //ASIGNAMOS LAS COMPARATIVAS
                    for(let a = 0;a < 12; a ++){
                        this.itemsSueldos[a].comparativa = comparativaSueldos[a].comparativa
                        let diferencia = this.itemsSueldos[a].importe - this.itemsSueldos[a].comparativa
                        this.itemsSueldos[a].diferencia = diferencia
                    }
                    for(let a = 0;a < 12; a ++){
                        this.itemsAsimilados[a].comparativa = comparativaAsimilados[a].comparativa
                        let diferencia = this.itemsAsimilados[a].importe - this.itemsAsimilados[a].comparativa
                        this.itemsAsimilados[a].diferencia = diferencia
                    }
                    for(let a = 0;a < 12; a ++){
                        this.itemsOtros[a].comparativa = comparativaOtros[a].comparativa
                        let diferencia = this.itemsOtros[a].importe - this.itemsOtros[a].comparativa
                        this.itemsOtros[a].diferencia = diferencia
                    }
                    this.loading = false
                }catch(error){
                    console.log(error)
                    this.loading = false
                }
            },
            
            async GetComparativa(año, tipo){
                let respuesta = [ ... this.tablaInicial ]
                try{
                    let response = await axios.get(this.rutaAxios + 'Comparativa/GetComparativaAsync/' + this.token.empresaBase + '_demo/' + año + '/' + tipo);
                    let datos = response.data
                    respuesta = [ ...datos ]
                    return respuesta;
                }catch(error){
                    // console.log(error);
                    return respuesta;
                }
            },

            async OpenDialoComparativa(item){
                if(!this.selectedAnio){
                    this.$toast.add({severity:'warn', summary: 'Preución', detail:'Seleccione un año', life: 3000});
                    return
                }

                this.loading = true;
                this.loadingMensaje = 'Consultando, espere...'
                if(item == 1){
                    this.comparativa.textoComparativa = 'Comparativa Sueldos y Salarios';
                    this.comparativa.año = this.selectedAnio;
                    this.comparativa.tipo = 'Sueldos';

                    this.comparativa.comparativa = await this.GetComparativa(this.selectedAnio, 'Sueldos');
                }
                if(item == 2){
                    this.comparativa.textoComparativa = 'Comparativa Asimilados';
                    this.comparativa.año = this.selectedAnio;
                    this.comparativa.tipo = 'Asimilados';
                    
                    this.comparativa.comparativa = await this.GetComparativa(this.selectedAnio, 'Asimilados');
                }
                if(item == 3){
                    this.comparativa.textoComparativa = 'Comparativa Sueldos Otros';
                    this.comparativa.año = this.selectedAnio;
                    this.comparativa.tipo = 'SueldosOtros';

                    this.comparativa.comparativa = await this.GetComparativa(this.selectedAnio, 'SueldosOtros');
                }
                this.dialogComparativa = true;
                this.loading = false;
            },
        
            CloseComparativa(){
                this.dialogComparativa = false;
                this.dialogDetalles = false;
            },
        
            OpenDialogDetalle(item, tipo){
                this.dialogDetalles = true;
                this.$store.state.isrDetallesStore.detalles = [ ...item.comprobantes ]
                this.$store.state.isrDetallesStore.tipo = tipo + '_' + item.mes + '_' + this.selectedAnio
                this.$store.state.isrDetallesStore.origen = 'ISR'
            },
        },
    }
</script>